'use strict';

import { view } from '@/functions';

const prefix = '/reconciliations';
const scopes = ['read_reconciliations', 'write_reconciliations'];
const component = () => view('reconciliations/index');

const tabs = [
    { path: '', tab: 'dashboard' },
    { path: '/files', tab: 'files' },
    { path: '/exceptions', tab: 'exceptions' },
    { path: '/settlements', tab: 'settlements' },
    { path: '/bank-settlements', tab: 'bank-settlements' },
    { path: '/configuration', tab: 'configuration' },
];

export default [
    ...tabs.map(({ path, tab }) => ({
        path: `${prefix}${path}`,
        name: `reconciliations-${tab}`,
        meta: { title: 'Reconciliations', scopes, tab },
        component,
    })),
    {
        path: String.raw`${prefix}/files/:id(\d+)`,
        name: 'reconciliations-file',
        meta: { title: 'Reconciliation file', scopes },
        component: () => view('reconciliations/file'),
        props: true,
    },
];
